<template>
  <div class="home xlbox" :style="{ height: pageHeight + 'px' }">
    <van-nav-bar
      fixed
      title="保护定值"
      left-text=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="tj" :style="{ height: pageHeight-46 + 'px' }">
      <van-sticky :offset-top="46" class="titfh">
        <p>基础信息</p>
      </van-sticky>
      <van-cell-group>
        <van-cell title="开关编号:" :value="this.listData.kgbh ? this.listData.kgbh:'/'" />
        <van-cell title="设备类型:" :value="this.listData.dtuType ? this.listData.dtuType:'/'" />
        <van-cell title="安装位置:" :value="this.listData.elepoId ? this.listData.elepoId:'/'" />
        <van-cell title="分界/分段:" :value="this.listData.fjfd ? this.listData.fjfd:'/'" />
      </van-cell-group>
      <van-sticky :offset-top="92" class="titfh">
        <p>变化信息</p>
      </van-sticky>
      <van-cell-group>
        <van-cell title="CT变比：" :value="this.listData.ctbh ? this.listData.ctbh:'/'" />
      </van-cell-group>
      <van-sticky :offset-top="138" class="titfh">
        <p>过流保护</p>
      </van-sticky>
      <van-cell-group>
        <van-cell title="Ⅰ段软压板:" :value="this.listData.ryb1 ? this.listData.ryb1:'/'" />
        <van-cell title="Ⅰ段定值：" :value="this.listData.dz1 ? this.listData.dz1:'/'" />
        <van-cell title="Ⅰ段时延：" :value="this.listData.sy1 ? this.listData.sy1:'/'" />
        <van-cell title="Ⅱ段软压板:" :value="this.listData.ryb2 ? this.listData.ryb2:'/'" />
        <van-cell title="Ⅱ段定值：" :value="this.listData.dz2 ? this.listData.dz2:'/'" />
        <van-cell title="Ⅱ段时延：" :value="this.listData.sy2 ? this.listData.sy2:'/'" />
      </van-cell-group>
      <van-sticky :offset-top="138" class="titfh">
        <p>零序接地</p>
      </van-sticky>
      <van-cell-group>
        <van-cell title="零序软压板" :value="this.listData.ryb0 ? this.listData.ryb0:'/'" />
        <van-cell title="零序定值：" :value="this.listData.dz0 ? this.listData.dz0:'/'" />
        <van-cell title="零序时延:" :value="this.listData.sy0 ? this.listData.sy0:'/'" />
        <van-cell title="零序电压定值：" :value="this.listData.dydz0 ? this.listData.dydz0:'/'" />
        <van-cell title="小电流告警投退:" :value="this.listData.xdlgjtt ? this.listData.xdlgjtt:'/'" />
        <van-cell title="小电流出口投退：" :value="this.listData.xdlcktt ? this.listData.xdlcktt:'/'" />
        <van-cell title="—次重合闸投入：" :value="this.listData.ycchztr ? this.listData.ycchztr:'/'" />
        <van-cell title="—次重合闸时间:" :value="this.listData.yxxhzsj ? this.listData.yxxhzsj:'/'" />
      </van-cell-group>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  Col,
  Row,
  Cell,
  CellGroup,
  Button,
  Icon,
  NavBar,
  List,
  PullRefresh,
  DropdownMenu,
  DropdownItem,
  Toast,
  Sticky
} from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(
  Col,
  Row,
  Cell,
  CellGroup,
  Button,
  Icon,
  NavBar,
  List,
  PullRefresh,
  DropdownMenu,
  DropdownItem,
  Toast,
  Sticky
)

export default {
  name: 'BHDZPage',
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Toast.name]: Toast,
    [Sticky.name]: Sticky
  },
  data () {
    return {
      count: 0,
      isLoading: false,
      loading: false,
      finished: false,
      pageHeight: window.innerHeight,
      searchId: '',
      mlineId: '', // 线路id
      elepoId: '3号杆塔',
      listData: {}

    }
  },
  created () {
    // console.log(222)
    this.mlineId = this.$route.query.mlineId // 传过来的线路id
    this.elepoId = this.$route.query.elepoId
    // console.log(this.mlineId)
    // console.log(this.elepoId)
    this.getBHDZList()
  },
  activated () {
    // console.log(1111)
    // 如果要在每次进入页面的时候获取最新的数据，需要在activated阶段获取数据，承担原来created钩子中获取数据的任务。
    this.mlineId = this.$route.query.mlineId // 传过来的线路id
    this.elepoId = this.$route.query.elepoId
    this.getBHDZList()
  },
  mounted () {
    this.mlineId = this.$route.query.mlineId // 传过来的线路id
  },
  methods: {
    onClickLeft () {
      // window.history.back()
      this.$router.go(-1) // 返回上一页面
    },
    getBHDZList () {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      })
      this.util.post('/getBHDZ', {
        mlineId: this.mlineId, // 线路id
        elepoId: this.elepoId // 杆塔id
      }).then(({ data }) => {
        if (data.code === 200) {
          console.log(data)
          this.listData = data.data.protectValueVO
          this.$nextTick(() => {
            Toast.clear()// 手动清除 Toast
          })
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    }

  },
  computed: {

  }
}
</script>

<style scoped lang="less">
/deep/.van-nav-bar{
  background: linear-gradient(227deg, #06C8B5 0%, #007CF8 100%);
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
  color: #fff;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #fff;
}
/deep/.van-dropdown-menu__bar {
  width: 100vw;
  height: 34px;
  position: fixed;
  left: 0;
  top: 56px;
  z-index: 2;
}
.home {
  background: #fff;
}
.tj{
  width: 100%;
  margin-top: 46px;
}
.van-cell-group .van-cell:nth-child(even) {
  background: #f9f9f9;
}
</style>
